export const KIND_WEASIS = 'weasis';
export const KIND_LAUNCHER = 'launcher';
export const KIND_JDK = 'jdk';
export const KIND_FFMPEG = 'ffmpeg';
export const KIND_INSTALLER = 'installer';

/** Public altındaki statik dosyanın tarayıcıdan indirilebilir adresi. */
export function publicLauncherUrl(fileName) {
    return `${window.AppSettings.server.api}/Public/launcher/${fileName}`;
}

export function formatBytes(bytes) {
    if (!bytes) return '-';
    const units = ['B', 'KB', 'MB', 'GB'];
    let value = bytes;
    let unit = 0;
    while (value >= 1024 && unit < units.length - 1) {
        value /= 1024;
        unit += 1;
    }
    return `${value.toFixed(unit === 0 ? 0 : 1)} ${units[unit]}`;
}

export function formatDate(value) {
    if (!value) return '—';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString();
}

export function byKind(artifacts, kind) {
    return (artifacts || []).filter(x => x.kind === kind);
}

/** Bir türün sürüm numaralarını büyükten küçüğe döner. */
export function versionsOf(artifacts, kind) {
    return [...new Set(byKind(artifacts, kind).map(x => x.version))].sort((a, b) => b - a);
}

export function findArtifact(artifacts, kind, version, platform = null) {
    return byKind(artifacts, kind).find(x => x.version === version && x.platform === platform);
}
